import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { loadEvent } from '~/state/modules/events'
import { Typography, Button } from '@material-ui/core'
import { ArrowBack } from '@material-ui/icons'
import { PaperContainer } from '~/views/shared'
import { SeatsDistribution } from './SeatsDistribution'
import { ROUTES } from '~/views/routes'
import history from '~/config/history'

export const SellSeatsPage = ({ onSuccess }) => {
  const { eventId, layoutId, sectorId } = useParams()
  const { sector } = useSelector((state) => state.planimetry)
  const { event } = useSelector((state) => state.events)

  const dispatch = useDispatch()

  const getSectorIndexUrl = () => {
    return ROUTES.ADMIN.EVENTS.SECTORS.INDEX.replace(
      ':eventId',
      eventId
    ).replace(':layoutId', layoutId)
  }

  const values = {
    SectorId: sectorId,
    Seats: [],
    Row: 0,
    Column: 0
  }

  useEffect(() => {
    async function fetchData() {
      await dispatch(loadEvent(eventId))
    }

    fetchData().then()
    // eslint-disable-next-line
  }, [])

  return (
    <>
      {event && (
        <Typography variant='h6' style={{ paddingInline: 8, paddingBottom: 8 }}>
          {`${event?.Title} (${event?.Id})`}{' '}
        </Typography>
      )}
      <PaperContainer
        title={
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              paddingInline: 16
            }}>
            <Typography
              style={{
                display: 'block',
                textAlign: 'center',
                fontSize: '1.2rem',
                fontWeight: 500
              }}>
              {`Venta Planimetria - Sector "${sector?.Name ?? '-'}"`}
            </Typography>
            <Button
              onClick={() => history.push(getSectorIndexUrl())}
              color='primary'
              startIcon={<ArrowBack />}>
              Volver a Sectores
            </Button>
          </div>
        }>
        <SeatsDistribution
          values={values}
          actionText='Crear'
          onCancel={() => history.push(getSectorIndexUrl())}
        />
      </PaperContainer>
    </>
  )
}

export default SellSeatsPage
